// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media print{.v-main{padding:0!important}.component--crud-data-table .v-card__title{display:none}}.logo{max-height:100%;max-width:100%}header>.v-toolbar__content{padding-top:0}.nav-subitem.v-list-item__title{font-size:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
